import Types from "./Types";
/* eslint-disable camelcase */

/************************************************
Get Order details
*************************************************/

const getOrdersV2 = (query, print) => {
  return { type: Types.GET_ORDERS_V2, query, print };
};

const getOrdersV2Success = orders => ({
  type: Types.GET_ORDERS_V2_SUCCESS,
  orders
});

const getOrdersV2Failure = error => ({
  type: Types.GET_ORDERS_V2_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const openPickup = warehouse => {
  return { type: Types.OPEN_PICKUP, warehouse };
};

const openPickupSuccess = close => {
  return {
    type: Types.OPEN_PICKUP_SUCCESS,
    close
  };
};

const openPickupFailure = error => ({
  type: Types.OPEN_PICKUP_FAILURE,
  error
});

/************************************************
Get Order details
*************************************************/

const getSingleOrder = (query, print) => {
  return { type: Types.GET_SINGLE_ORDER, query };
};

const getSingleOrderSuccess = orders => ({
  type: Types.GET_SINGLE_ORDER_SUCCESS,
  orders
});

const getSingleOrderFailure = error => ({
  type: Types.GET_SINGLE_ORDER_FAILURE,
  error
});

/************************************************
Get Order details
*************************************************/

const getOrderCount = (query) => {
  return { type: Types.GET_ORDER_COUNT, query };
};

const getOrderCountSuccess = orderCount => {
  return({
  type: Types.GET_ORDER_COUNT_SUCCESS,
  orderCount
})};

const getOrderCountFailure = error => ({
  type: Types.GET_ORDER_COUNT_FAILURE,
  error
});

/************************************************
Get Reserved Order details
*************************************************/

const postPickupV2 = (query, remove) => {
  return { type: Types.POST_PICKUP_V2, query, remove };
};

const postPickupV2Success = orders => ({
  type: Types.POST_PICKUP_V2_SUCCESS,
  orders
});

const postPickupV2Failure = error => ({
  type: Types.POST_PICKUP_V2_FAILURE,
  error
});

/* Accept orders */
const postOrdersV2 = (orders: Object, params: string) => {
  return {
    type: Types.POST_ORDERS_V2,
    orders,
    params
  };
};

const postOrdersV2Success = (orders: Object, params: string) => {
  return {
    type: Types.POST_ORDERS_V2_SUCCESS,
    orders,
    params
  };
};

const postOrdersV2Failure = (error: Object) => {
  return {
    type: Types.POST_ORDERS_V2_FAILURE,
    error
  };
};

/************************************************
Print Order details
*************************************************/

const printOrder = query => {
  return { type: Types.PRINT_ORDER, query };
};

const printOrderSuccess = () => ({ type: Types.PRINT_ORDER_SUCCESS });

const printOrderFailure = error => ({
  type: Types.PRINT_ORDER_FAILURE,
  error
});

/****************
***********
Deprecated orders
***********
**********/

/************************************************
Get Order details
*************************************************/

const getOrders = query => {
  return { type: Types.GET_ORDERS, query };
};

const getOrdersSuccess = orders => ({ type: Types.GET_ORDERS_SUCCESS, orders });

const getOrdersFailure = error => ({
  type: Types.GET_ORDERS_FAILURE,
  error
});

/************************************************
Get Reserved Order details
*************************************************/

const getReservedOrders = query => {
  return { type: Types.GET_RESERVED_ORDERS, query };
};

const getReservedOrdersSuccess = orders => ({
  type: Types.GET_RESERVED_ORDERS_SUCCESS,
  orders
});

const getReservedOrdersFailure = error => ({
  type: Types.GET_RESERVED_ORDERS_FAILURE,
  error
});

/* Accept orders */
const postOrders = (orders: Object, params: string) => {
  return {
    type: Types.POST_ORDERS,
    orders,
    params
  };
};

const postOrdersSuccess = (orders: Object, params: string) => {
  return {
    type: Types.POST_ORDERS_SUCCESS,
    orders,
    params
  };
};

const postOrdersFailure = (error: Object) => {
  return {
    type: Types.POST_ORDERS_FAILURE,
    error
  };
};

/********
*********
End of Deprecated
********
********/

export {
  getOrdersV2,
  getOrdersV2Success,
  getOrdersV2Failure,
  getSingleOrder,
  getSingleOrderSuccess,
  getSingleOrderFailure,
  postOrdersV2,
  postOrdersV2Success,
  postOrdersV2Failure,
  postPickupV2,
  postPickupV2Success,
  postPickupV2Failure,
  printOrder,
  printOrderSuccess,
  printOrderFailure,
  getOrders,
  getOrdersSuccess,
  getOrdersFailure,
  postOrders,
  postOrdersSuccess,
  postOrdersFailure,
  getReservedOrders,
  getReservedOrdersSuccess,
  getReservedOrdersFailure,
  getOrderCount,
  getOrderCountSuccess,
  getOrderCountFailure,
  openPickup,
  openPickupSuccess,
  openPickupFailure
};



// WEBPACK FOOTER //
// ./src/actions/OrdersActions.js